import { useState } from 'react';
import { StarFilledIcon } from '@m/alchemy-ui/icons/StarFilledIcon';
import { useIntl } from 'react-intl';
import { useRuntimeCommunity } from '../../../context';
import * as Styled from './VoteActions.styled';

interface StarVoteProps {
  readonly maxStars: number;
  readonly localVote: number | null;
  readonly disabled: boolean;
  readonly onVote: (direction: number) => void;
}

export const StarVote = ({ maxStars, localVote, disabled, onVote }: StarVoteProps) => {
  const { colors } = useRuntimeCommunity();
  const intl = useIntl();
  const buttonColor = colors?.button ? `#${colors.button}` : '#f5a623';
  const [hoveredStar, setHoveredStar] = useState<number | null>(null);

  return (
    <Styled.StarVoteWrap>
      {Array.from({ length: maxStars }, (_, i) => {
        const starValue = i + 1;
        const isActive = hoveredStar === null ? localVote !== null && starValue <= localVote : starValue <= hoveredStar;
        const starLabel = intl.formatMessage(
          { id: 'castStarVote', defaultMessage: 'Cast {count, plural, one {# star} other {# stars}} vote' },
          { count: starValue }
        );
        const starTitle = intl.formatMessage(
          { id: 'starCount', defaultMessage: '{count, plural, one {# star} other {# stars}}' },
          { count: starValue }
        );

        return (
          <Styled.StarButton
            key={starValue}
            $active={isActive}
            $buttonColor={buttonColor}
            disabled={disabled}
            onClick={() => onVote(starValue)}
            onMouseEnter={() => !disabled && setHoveredStar(starValue)}
            onMouseLeave={() => setHoveredStar(null)}
            aria-label={starLabel}
            aria-pressed={localVote === starValue ? 'true' : 'false'}
            title={starTitle}
            type="button"
          >
            <StarFilledIcon aria-hidden="true" />
          </Styled.StarButton>
        );
      })}
    </Styled.StarVoteWrap>
  );
};
